module.exports = __webpack_public_path__ + "img/help-notifs-profile.6b80ef25.png";